import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {EmailPrlObj, MarketingToolsDataPrlObj, ZoneLightPrlObj} from '../../../../../generated/generated.model';
import {CampaignProfilePrlObj, InvocationCodeParamsMxObj, InvocationCodeResultMxObj} from 'mx-core';

const MARKETING_TOOLS_REST_URL: string = '/rest/marketing-tools/';

export interface SearchData {
    subTypeIds: string[];
    productIds: string[];
    languages: string[];
    currencies: string[];
    description: string | null;
    creativeDescription: string | null;
    order: string[];
    orderBy: string;
}

@Injectable({
    providedIn: 'root'
})
export class PrlMarketingToolsService {

    private profiles: Map<number, CampaignProfilePrlObj[]>;
    constructor(
        private httpClient: HttpClient
    ) {
    }

    public getProfiles(): Map<number, CampaignProfilePrlObj[]> {
        return this.profiles;
    }

    public setProfiles(profiles: Map<number, CampaignProfilePrlObj[]>) {
        this.profiles = profiles;
    }

    public getFiltersData(): Observable<MarketingToolsDataPrlObj> {
        return this.httpClient.get<MarketingToolsDataPrlObj>(MARKETING_TOOLS_REST_URL + 'full-data');
    }

    public getLightZones(criteria: SearchData): Observable<ZoneLightPrlObj[]> {
        return this.httpClient.post<ZoneLightPrlObj[]>(MARKETING_TOOLS_REST_URL + 'light-zones', criteria);
    }

    public getLightZone(id: number): Observable<ZoneLightPrlObj> {
        return this.httpClient.get<ZoneLightPrlObj>(MARKETING_TOOLS_REST_URL + 'light-zones/' + id);
    }

    public getInvocationCode(params: Partial<InvocationCodeParamsMxObj>): Observable<InvocationCodeResultMxObj> {
        return this.httpClient.post<InvocationCodeResultMxObj>(MARKETING_TOOLS_REST_URL + 'invocation-code', params);
    }

    public getInvocationCodeEmailContent(params: Partial<InvocationCodeParamsMxObj>): Observable<EmailPrlObj> {
        return this.httpClient.post<EmailPrlObj>(MARKETING_TOOLS_REST_URL + 'invocation-code-email-content', params);
    }

    public loadProfiles(): Observable<Map<number, CampaignProfilePrlObj[]>> {
        return this.httpClient.get<Map<number, CampaignProfilePrlObj[]>>(MARKETING_TOOLS_REST_URL + 'profiles/clean');
    }
}